import {c as createCommonjsModule, g as getDefaultExportFromCjs} from "../../common/_commonjsHelpers-8c19dec8.js";
import {i as interopRequireDefault} from "../../common/interopRequireDefault-d2c9da36.js";
import {e as esm} from "../../common/defaultTheme-ca6a0b43.js";
import {s as styles} from "../../common/index-fe254d98.js";
import "../../common/capitalize-c580b26a.js";
import "../../common/index-877ea290.js";
import "../../common/hoist-non-react-statics.cjs-7c8198a1.js";
import "../../common/colorManipulator-ba921df7.js";
import "../../common/useForkRef-edb3fede.js";
import "react";
import "../../common/emotion-element-99289b21.browser.esm-15d91a3a.js";
import "../../common/useTheme-81ac7d8e.js";
import "../../common/useEventCallback-4c5b62b3.js";
import "../../common/clsx.m-5dc7436b.js";
import "react/jsx-runtime";
import "../../common/nested-5a43708e.js";
import "../../common/useTheme-ad5c2c5a.js";
import "../../common/useThemeProps-ef190a94.js";
var Box_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  const defaultTheme = (0, styles.createTheme)();
  const Box2 = (0, esm.createBox)({
    defaultTheme
  });
  var _default = Box2;
  exports.default = _default;
});
var Box = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
      return _Box.default;
    }
  });
  var _Box = interopRequireDefault(Box_1);
});
var __pika_web_default_export_for_treeshaking__ = /* @__PURE__ */ getDefaultExportFromCjs(Box);
export default __pika_web_default_export_for_treeshaking__;
